import { dispatch, getDataFromStore } from "../store/store";

import {
  setIsAppLoading,
  setIsTabLoading,
  setIsChatVisible,
  setIsOrbitSessionData,
  setPharmacy,
  setTeam,
  setDarkModeTheme,
  setAuthToken,
  setOrbitUser,
  getAppData,
  setPharmaciesData,
  resetAppState,
  replaceAppState,
  removeAuthToken,
  setIsSelectionScreenData,
  userChangeCompanyData,
  getCompanyNamesData,
  updateLastLoginByEmailData,
  updateUserCurrentStatusData,
  updateLogoutByEmailData,
  setIsTeamUpdatedData,
  setIsSelectedTeamIndexData,
  setShowPatientSearchModalData,
  setHeaderTeamMembersData,
  setShowInviteModalData,
  setGlobalTab,
  setShowInviteTeamSideModalData,
  setisAgencyUserData,
  setGlobalTabText,
  setCurrentPatientInfoTab,
  setCurrentIsPatientSearched,
  getIntercomDetailData,
  setCurrentTeamsData,
  setRoutedFromSchedulerData,
  setShowProfileModalData,
  setConsultationLoadErrorData,
  getDemDxDetailData,
  setShowIdlePopupData,
  setShowSettingsModalData,
  setSettingsActiveTabData,
  setShowPermissionModalData,
  setShowPermissionMessageData,
  setCompanyIdData,
  setCurrentCompanyIdData,
  setGroupModeCompanyIdData,
  setDasboardTeam,
} from "../features/appSlice/appSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "app";

// #region State Setters
export const setDarkMode = (isDarkMode) => {
  const darkMode = getDataFromStore(reducerName, "darkMode");
  if (isDarkMode !== darkMode) {
    dispatch(setDarkModeTheme(isDarkMode));
  }
};

export const toggleTheme = () => {
  const darkMode = getDataFromStore(reducerName, "darkMode") || false;
  setDarkMode(!darkMode);
};

export const setChatVisible = (isVisible) => {
  dispatch(setIsChatVisible(isVisible));
};

export const setIsOrbitSession = (isVisible) => {
  dispatch(setIsOrbitSessionData(isVisible));
};
export const setIsOrbitUser = (isOrbitUser) => {
  dispatch(setOrbitUser(isOrbitUser));
};
export const setIsSelectionScreen = (isSelectionScreen) => {
  dispatch(setIsSelectionScreenData(isSelectionScreen));
};

export const toggleChat = () => {
  const isChatVisible = getDataFromStore(reducerName, "isChatVisible") || false;
  setChatVisible(!isChatVisible);
};

export const setAppLoading = (isLoading) => {
  dispatch(setIsAppLoading(isLoading));
};

export const setTabLoading = (isLoading) => {
  dispatch(setIsTabLoading(isLoading));
};

export const setCurrentPharmacy = (pharmacy) => {
  dispatch(setPharmacy(pharmacy));
};

export const setCurrentTeam = (team) => {
  dispatch(setTeam(team));
};
export const setIsTeamUpdated = (value) => {
  dispatch(setIsTeamUpdatedData(value));
};
export const setSelectedTeamIndex = (value) => {
  dispatch(setIsSelectedTeamIndexData(value));
};
export const replaceState = (appData) => {
  dispatch(replaceAppState(appData));
};

export const resetApp = () => {
  dispatch(resetAppState());
};

export const setAuth = (newAuthToken) => {
  dispatch(setAuthToken(newAuthToken));
};

export const setPharmacies = (pharmacies) => {
  dispatch(setPharmaciesData(pharmacies));
};

export const removeAuth = () => {
  dispatch(removeAuthToken());
};

export const setShowPatientSearchModal = (value) => {
  dispatch(setShowPatientSearchModalData(value));
};

export const setHeaderTeamMembers = (value) => {
  dispatch(setHeaderTeamMembersData(value));
};

export const setShowInviteModal = (value) => {
  dispatch(setShowInviteModalData(value));
};

export const setShowInviteTeamSideModal = (value) => {
  dispatch(setShowInviteTeamSideModalData(value));
};

export const setCurrentGlobalTabValue = (tabValue) => {
  localStorage.setItem("globalTab", tabValue); // Store the selected tab
  dispatch(setGlobalTab(tabValue));
};
export const setCurrentGlobalTabText = (tabValue) => {
  localStorage.setItem("globalTabText", tabValue); // Store the selected tab
  dispatch(setGlobalTabText(tabValue));
};

export const setisAgencyUser = (value) => {
  dispatch(setisAgencyUserData(value));
};
export const setisPatientSearched = (value) => {
  dispatch(setCurrentIsPatientSearched(value));
};
export const setPatientInfoTab = (tabValue) => {
  localStorage.setItem("patientInfoTab", tabValue); // Store the selected tab
  dispatch(setCurrentPatientInfoTab(tabValue));
};
export const setCurrentTeams = (value) => {
  dispatch(setCurrentTeamsData(value));
};
export const setRoutedFromScheduler = (value) => {
  dispatch(setRoutedFromSchedulerData(value));
};
export const setShowProfileModal = (value) => {
  dispatch(setShowProfileModalData(value));
};
export const setConsultationLoadError = (value) => {
  dispatch(setConsultationLoadErrorData(value));
};
export const setShowIdlePopup = (value) => {
  dispatch(setShowIdlePopupData(value));
};
export const setShowSettingsModal = (value) => {
  dispatch(setShowSettingsModalData(value));
};

export const setShowPermissionModal = (value) => {
  dispatch(setShowPermissionModalData(value));
};

export const setShowPermissionMessage = (value) => {
  dispatch(setShowPermissionMessageData(value));
};

export const setSettingsActiveTab = (value) => {
  dispatch(setSettingsActiveTabData(value));
  
};
export const setCompanyId = (value) => {
  dispatch(setCompanyIdData(value));
};
export const setCurrentCompanyId = (value) => {
  dispatch(setCurrentCompanyIdData(value));
};
export const setGroupModeCompanyId = (value) => {
  dispatch(setGroupModeCompanyIdData(value));
};
export const setDasboardTeams = (team) => {
  dispatch(setDasboardTeam(team));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getApplicationData = async (featureSearchType = 6) => {
  let result = null;
  try {
    result = dispatch(getAppData(featureSearchType)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, featureSearchType);
    result = null;
  }

  return result;
};
export const userChangeCompany = async (params) => {
  let result = null;
  try {
    result = dispatch(userChangeCompanyData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const getCompanyNames = async (params) => {
  let result = null;
  try {
    result = dispatch(getCompanyNamesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const updateLastLoginByEmail = async () => {
  let result = null;

  try {
    result = await dispatch(updateLastLoginByEmailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};
export const updateUserCurrentStatus = async (statusType) => {
  let result = null;
  try {
    result = await dispatch(updateUserCurrentStatusData(statusType)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, statusType);
    result = null;
  }

  return result;
};
export const updateLogoutByEmail = async () => {
  let result = null;

  try {
    result = await dispatch(updateLogoutByEmailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const getIntercomDetail = async () => {
  let result = null;
  try {
    result = dispatch(getIntercomDetailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const getDemDxDetail = async () => {
  let result = null;
  try {
    result = dispatch(getDemDxDetailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};
// #endregion
